import { render } from "./modalViewUser.vue?vue&type=template&id=4fa234d0&scoped=true"
import script from "./modalViewUser.vue?vue&type=script&lang=js"
export * from "./modalViewUser.vue?vue&type=script&lang=js"

import "./modalViewUser.vue?vue&type=style&index=0&id=4fa234d0&scoped=true&lang=css"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa234d0"]])

export default __exports__